// Shared reduced-motion check — every landing-page animation (hero entrance,
// drifting background, floating preview panel, carousel auto-advance,
// scroll fade-ins, count-ups) reads this before animating, per the OS/
// browser accessibility setting. `prefersReducedMotion()` is a plain
// function (safe to call inside a gsap-driving useEffect, not just at
// render time); `usePrefersReducedMotion()` is the same check as a hook for
// components that need to react to the setting changing mid-session.
import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(prefersReducedMotion);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setReduced(mql.matches);
    // Safari < 14 only supports addListener/removeListener; feature-detect
    // rather than assuming the modern EventTarget API is present.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return reduced;
}

export default usePrefersReducedMotion;
